export default {
    name: 'Users'
}
